# Användarvillkor för Safe Learning Management System

## 1\. Introduktion

Dessa användarvillkor ("Villkor") reglerar din tillgång till och användning av Safe Learning Management System ("Tjänsten") som tillhandahålls av Safe Asset Group International AB ("vi", "oss" eller "vår"). Genom att komma åt eller använda tjänsten samtycker du till att vara bunden av dessa villkor. Om du inte håller med om någon del av Villkoren får du inte komma åt Tjänsten.

## 2\. Ändringar av villkoren

Vi förbehåller oss rätten att när som helst ändra eller ersätta dessa villkor. Vi kommer att meddela alla väsentliga ändringar genom att publicera de nya villkoren på denna sida. Din fortsatta användning av tjänsten efter sådana ändringar innebär att du accepterar de nya villkoren.

## 3\. Tillgång till tjänsten

3.1. Tjänsten är endast tillgänglig för användare som har försetts med kurskoder eller har beviljats ​​åtkomst till Tjänstens administrativa portal.

3.2. Du ansvarar för att upprätthålla sekretessen för dina kurskoder och kontouppgifter, och för alla aktiviteter som sker under ditt konto.

## 4\. Användarbeteende

Du samtycker till att endast använda tjänsten för lagliga ändamål och i enlighet med dessa villkor. Du samtycker till att inte:

4.1. Använd tjänsten på något sätt som bryter mot tillämplig lokal, nationell eller internationell lag eller förordning.

4.2. Försök att få obehörig åtkomst till någon del av tjänsten eller andra system eller nätverk som är anslutna till tjänsten.

4.3. Använd tjänsten för att överföra data eller skicka eller ladda upp material som innehåller virus, trojanska hästar, maskar, tidsbomber, tangenttryckningsloggare, spionprogram, adware eller andra skadliga program eller liknande datorkod som utformats för att negativt påverka driften av någon datorprogramvara eller hårdvara.

4.4. Använd valfri robot, spindel eller annan automatisk enhet, process eller medel för att komma åt Tjänsten för alla ändamål, inklusive övervakning eller kopiering av något av materialet på Tjänsten.

## 5\. Immateriella rättigheter

5.1. Tjänsten och dess ursprungliga innehåll, funktioner och funktionalitet är och kommer att förbli den exklusiva egendomen av Safe Asset Group International AB och dess licensgivare.

5.2. Du beviljas en begränsad licens att få tillgång till och använda Tjänsten och att ladda ner och skriva ut kursmaterial för ditt personliga, icke-kommersiellt bruk.

## 6\. Användarinnehåll

6.1. Du behåller alla dina rättigheter till allt innehåll du skickar, lägger upp eller visar på eller genom Tjänsten ("Användarinnehåll").

6.2. Genom att publicera användarinnehåll ger du oss rätten och licensen att använda, modifiera, offentligt utföra, offentligt visa, reproducera och distribuera sådant användarinnehåll på och genom tjänsten.

## 7\. Uppsägning

7.1. Vi kan avsluta eller stänga av din åtkomst till tjänsten omedelbart, utan föregående meddelande eller ansvar, oavsett anledning, inklusive utan begränsning om du bryter mot villkoren.

7.2. Vid uppsägning upphör din rätt att använda Tjänsten omedelbart.

## 8\. Ansvarsbegränsning

8.1. Under inga omständigheter ska Safe Asset Group International AB, eller dess styrelseledamöter, anställda, partners, agenter, leverantörer eller dotterbolag, hållas ansvariga för några indirekta, tillfälliga, speciella, följdskador eller straffskador, inklusive men inte begränsat till förlust av vinst, data, användning, goodwill eller andra immateriella förluster, som härrör från din tillgång till eller användning av eller oförmåga att få tillgång till eller använda tjänsten.

## 9\. Ansvarsfriskrivning

9.1. Din användning av tjänsten sker på egen risk. Tjänsten tillhandahålls på basis av "I BEFINTLIGT SKICK" och "SOM TILLGÄNGLIG".

9.2. Vi garanterar inte att Tjänsten kommer att vara oavbruten, läglig, säker eller felfri.

## 10\. Tillämplig lag

Dessa villkor ska styras och tolkas i enlighet med svensk lag, utan hänsyn till dess lagkonfliktbestämmelser.

## 11\. Ändringar av tjänsten

Vi förbehåller oss rätten att dra tillbaka eller ändra Tjänsten och all tjänst eller material som vi tillhandahåller via Tjänsten, efter eget gottfinnande utan föregående meddelande. Vi kommer inte att hållas ansvariga om hela eller delar av tjänsten av någon anledning är otillgänglig när som helst eller under någon period.

## 12\. Kontakta oss

Om du har några frågor om dessa villkor, vänligen kontakta oss på:

Safe Asset Group International AB  
Kivra: 559072-8746  
106 31 Stockholm  
Sverige

E-post: [info@safeassetgroup.com](mailto:info@safeassetgroup.com)  
Telefon: \+46 31 201 000

Senast uppdaterad: 2024-09-05
